import {v4 as uuid} from 'uuid'

export type HashMap<T> = Record<string, T>

export const createHashMap = <T>(items: T[]): Record<string, T> => {
  return items.reduce((acc, i) => {
    const id = uuid()
    acc[id] = i

    return acc
  }, {} as Record<string, T>)
}

// Remove the key-value pair from the HashMap.
export const removeHashMapProperty = <T>(
  map: Record<string, T>,
  key: string,
): Record<string, T> => {
  return Object.entries(map).reduce((p, [k, v]) => {
    if (k === key) return p
    return {...p, [k]: v}
  }, {} as Record<string, T>)
}

export type Ordered = {
  // Position starts off as undefined, and we'll sort those last by default. This
  // prevents any position discrepencies between clients from inserting an item
  // in any position other than last.
  position?: number
}

// Returns the ids in an array sorted by their position property.
export function orderedIdsByPosition(items: HashMap<Ordered>) {
  return Object.entries(items)
    .sort(([_aId, {position: aPosition}], [_bId, {position: bPosition}]) => {
      // Place items without positions last
      if (!aPosition) {
        return 1
      }

      if (!bPosition) {
        return -1
      }

      return aPosition - bPosition
    })
    .map(([id]) => id)
}

// Converts an ordered array of ids into a collection of
// objects with positions according to their index.
export function createPositions<T extends string | number>(ids: T[]) {
  return ids.reduce((acc, id, index) => {
    acc[id] = {position: index + 1}
    return acc
  }, {} as Record<T, {position: number}>)
}
